import {Component, Input} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import Commons from '../../pages/commons';

@Component({
    selector: 'panel',
    templateUrl: './panel.component.html'
})
export class PanelWidget {
    @Input() title: string;
    @Input() icon: string;
    @Input() showGoBack: boolean = false;
    @Input() goBackLink: string;

    constructor(private location: Location, private router: Router) {
    }

    back() {
        if (this.goBackLink) {
            if (this.goBackLink.includes('http') || this.goBackLink.includes('https')) {
                window.location.href = this.goBackLink;
            } else {
                this.router.navigate([this.goBackLink])
            }
        } else {
            this.location.back()
        }
    }
}
